export default __webpack_public_path__ + "static/media/m-background.97dc3881.png";